import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { Reveal, PlatformBadge } from "@/components/marketing/kit";

const img = {
  beauty: "https://images.unsplash.com/photo-1596704017254-9b121068fb31?crop=entropy&cs=srgb&fm=jpg&q=85&w=700&h=700&fit=crop",
  fashion: "https://images.unsplash.com/photo-1538329972958-465d6d2144ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=700&h=700&fit=crop",
  gaming: "https://images.unsplash.com/photo-1647654034000-0010c45a569d?crop=entropy&cs=srgb&fm=jpg&q=85&w=700&h=700&fit=crop",
  food: "https://images.unsplash.com/photo-1590557645008-95a81e206aac?crop=entropy&cs=srgb&fm=jpg&q=85&w=700&h=700&fit=crop",
  fitness: "https://images.unsplash.com/photo-1578938316366-341dc8b6e324?crop=entropy&cs=srgb&fm=jpg&q=85&w=700&h=700&fit=crop",
  travel: "https://images.unsplash.com/photo-1593501741239-37e686a6d615?crop=entropy&cs=srgb&fm=jpg&q=85&w=700&h=700&fit=crop",
};
const SOLS = [
  { img: img.beauty, platform: "instagram", t: "Beauty & Skincare", p: "Launch products with trusted reviewers and glow-up reels that convert browsers into buyers.", tags: ["Product seeding", "UGC", "Before/after"] },
  { img: img.fashion, platform: "tiktok", t: "Fashion & Apparel", p: "Drive drops and try-on hauls with style creators your target audience already copies.", tags: ["Drops", "Try-on hauls", "Lookbooks"] },
  { img: img.gaming, platform: "tiktok", t: "Gaming & Tech", p: "Reach high-intent communities with demos, reviews and streams from credible tech voices.", tags: ["Reviews", "Streams", "Unboxings"] },
  { img: img.food, platform: "instagram", t: "Food & Beverage", p: "Make mouths water with recipe reels and location features that spike foot traffic and orders.", tags: ["Recipes", "Reviews", "Local reach"] },
  { img: img.fitness, platform: "tiktok", t: "Health & Fitness", p: "Build credibility with routines, challenges and transformations from wellness creators.", tags: ["Challenges", "Routines", "Supplements"] },
  { img: img.travel, platform: "instagram", t: "Travel & Hospitality", p: "Fill rooms and itineraries with aspirational destination content and honest guides.", tags: ["Destination", "Guides", "Experiences"] },
];

export default function Solutions() {
  return (
    <main>
      <section className="mk-sec" style={{ paddingBottom: 30 }}><div className="mk-wrap mk-head">
        <Reveal><span className="mk-pill"><Sparkles size={14} /> Built for your industry</span></Reveal>
        <Reveal delay={0.08}><h1 className="mk-h2" style={{ fontSize: "clamp(32px,4.6vw,56px)" }} data-testid="solutions-title">Creator strategies tuned to your category</h1></Reveal>
        <Reveal delay={0.16}><p data-testid="solutions-description">From beauty to gaming, HypeFlow adapts discovery, briefs and benchmarks to how your audience actually buys.</p></Reveal>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap">
        <div className="mk-sol-grid">{SOLS.map((s, i) => (
          <Reveal key={s.t} delay={(i % 3) * 0.08}><div className="mk-sol" data-testid={`solution-${i}`}>
            <img src={s.img} alt={s.t} loading="lazy" /><div className="ov" />
            <PlatformBadge platform={s.platform} />
            <h3>{s.t}</h3><p>{s.p}</p>
            <div className="tags">{s.tags.map(t => <span key={t}>{t}</span>)}</div>
          </div></Reveal>
        ))}</div>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap"><div className="mk-cta">
        <span className="mk-pill" style={{ margin: "0 auto" }}><Sparkles size={14} /> Don't see your category?</span>
        <h2>HypeFlow works for any creator-led brand</h2>
        <p>Tell us your market and we'll show you the creators and playbook that fit.</p>
        <div className="mk-cta-actions"><Link to="/login?mode=register" className="mk-btn primary lg" data-testid="solutions-final-trial">Start free <ArrowRight size={17} /></Link><Link to="/contact" className="mk-btn ghost lg">Talk to us</Link></div>
      </div></div></section>
    </main>
  );
}
